export const mockData = {
    personalInfo: {
        name: "Manav Gupta",
        title: "Software Engineer",
        location: "Hyderabad, India",
        phone: "+91-9070507555",
        email: "manav_guptaa@outlook.com",
        avatar: "/images/profile/image.webp",
        bio: "I'm a passionate software engineer with experience building scalable mobile and web applications. I specialize in Flutter for cross-platform mobile development, React for modern web interfaces, and have expertise in full-stack development.",
        fullBio: "As a dedicated software engineer, I bring expertise in mobile-first thinking and full-stack development to every project. My journey began with a fascination for creating seamless user experiences across platforms, leading me to specialize in Flutter development where I've built applications for various industries including real estate, automotive, and education. My experience spans from frontend development with React to building robust mobile applications with Flutter, always focusing on clean code, performance optimization, and staying current with emerging technologies.",
        resume: "/images/resume/Manav_Gupta_Resume.pdf",
        socialLinks: {
            github: "https://github.com/manavg005",
            linkedin: "https://linkedin.com/in/manavg005",
            twitter: "https://twitter.com/manavg005",
            medium: "https://medium.com/@manavguptamg1990",
            instagram: "https://instagram.com/manavgupta"
        },
        beyondOffice: {
            tagline: "Engineer by day, wanderer by weekends",
            description: [
                "When the laptop shuts, a different side of me takes over - road trips, gym sessions, and good music. I like exploring places that aren't on the first page of Google, with a growing list of \"next time for sure\" destinations.",
                "Nothing resets me quite like the mountains. My legs have taken me up to 14,500 ft - high enough to question my life choices, low enough to still brag about it at sea level.",
                "Sunrises, sunsets, and the moon still manage to stop me mid-scroll. I'll never not look up."
            ],
            signOff: "Fuelled by curiosity, coffee, and a healthy disregard for comfort zones.",
            interests: [
                { name: "Fitness", icon: "💪" },
                { name: "Music", icon: "🎵" },
                { name: "Mountains", icon: "🏔️" },
                { name: "Reading", icon: "📚" },
                { name: "Coffee", icon: "☕" },
                { name: "Mindfulness", icon: "🧘" }
            ],
            gallery: [
                { src: "/images/personal/travel1.webp", alt: "Mountain adventure", emoji: "🏔️" },
                { src: "/images/personal/travel2.webp", alt: "City exploration", emoji: "🌆" },
                { src: "/images/personal/travel3.webp", alt: "Road trip vibes", emoji: "🛣️" },
                { src: "/images/personal/travel4.webp", alt: "Sunset moments", emoji: "🌅" },
                { src: "/images/personal/travel5.webp", alt: "Local discoveries", emoji: "📍" }
            ],
            stats: [
                { label: "Cities", value: "6+" },
                { label: "Countries", value: "1" },
                { label: "Coffee/Day", value: "∞" }
            ]
        }
    },
    
workExperience: [
    {
        id: 1,
        company: "Grarri Pvt Ltd",
        position: "Software Engineer",
        duration: "Nov 2024 - Present",
        location: "Hyderabad, India",
        type: "Full-time",
        description: "Leading product development and technical architecture for the company's flagship real estate application.",
        achievements: [
            "Own the end-to-end product and tech architecture for the company's main real estate app",
            "Built a smart home planning tool with a budget calculator that factors in location and realistic costs",
            "Designed a system for verified, non-repeated property listings with full details, monthly updates, pricing, and floor plans",
            "Built a user journey system that lets users save, share, and track property options, and personal notes"
        ],
        technologies: ["Flutter", "Dart", "Bloc", "Firebase", "Proptech", "CRM Systems"]
    },
    {
        id: 2,
        company: "Appventurez Mobitech",
        position: "Software Developer",
        duration: "June 2023 - Oct 2024",
        location: "Noida, India",
        type: "Full-time",
        description: "Built Flutter applications for Android and iOS with REST API integrations for real-time data.",
        achievements: [
            "Developed cross-platform Flutter apps handling real-time data through REST APIs",
            "Improved delivery times by 20% by optimising location services with Google Maps SDK",
            "Implemented offline functionality using Hive and SQLite for local storage",
            "Used Provider and Bloc for scalable state management across multiple apps",
            "Integrated Twilio Voice SDK, boosting user engagement by 30%"
        ],
        technologies: ["Flutter", "REST APIs", "Google Maps SDK", "Hive", "SQLite", "Provider", "Bloc", "Twilio"]
    },
    {
        id: 3,
        company: "JaKeGA, JKIT",
        position: "Software Developer Intern",
        duration: "Dec 2022 - June 2023",
        location: "Jammu, India",
        type: "Internship",
        description: "Built and maintained ICT solutions for J&K UT government departments.",
        achievements: [
            "Developed ICT-based solutions used across J&K UT departments",
            "Built an Attendance Management App in Flutter that cut manual effort by 50%",
            "Added geofencing and face recognition for streamlined attendance tracking"
        ],
        technologies: ["Flutter", "Geofencing", "Face Recognition", "ICT Solutions"]
    },
    {
        id: 4,
        company: "Devsnest",
        position: "Software Developer Intern",
        duration: "April 2021 - Dec 2021",
        location: "Gurugram, India",
        type: "Internship",
        description: "Built the frontend for an ed-tech platform using React, improving user experience and engagement.",
        achievements: [
            "Developed the React frontend for an ed-tech platform used by students",
            "Automated Discord group management through SQS, reducing overhead by 40%",
            "Built a Monaco-based code editor with real-time testing — retention up 15%, visits up 20%"
        ],
        technologies: ["React", "Discord API", "SQS", "Monaco Editor", "Real-time Testing"]
    }
],
    projects: [
        {
            id: 1,
            title: "SimpSocial GoCRM",
            description: "Automotive Dealership CRM - An AI-powered, cross-platform CRM to optimize sales processes for automotive dealerships.",
            longDescription: "Developed an AI-powered, cross-platform CRM to optimize sales processes for automotive dealerships, boosting customer engagement and sales conversions. Integrated communication tools, real-time lead management, and a bilingual conversational AI to streamline operations and enhance productivity.",
            image: "/images/projects/simpsocial.webp",
            cardImage: "/images/projects/simpsocial_project_card.webp",
            technologies: ["Flutter", "Twilio", "JitsiMeet", "Intercom", "AI", "CRM"],

            playstore: "https://play.google.com/store/apps/details?id=com.simpsocial.mobileApp&pcampaignid=web_share",
            appstore: "https://apps.apple.com/in/app/simpsocial-gocrm/id6502897000",
            featured: false,
            status: "completed",
            year: "2024"
        },
        {
            id: 2,
            title: "Football Lounge",
            description: "Sports & Social App - A mobile application that simulates real-time football conversations and knowledge-based games among friends.",
            longDescription: "Developed a mobile application that simulates real-time football conversations and knowledge-based games among friends. Implemented features for creating and managing tournaments, a point-based scoring system for correct predictions, and a chatroom with multimedia sharing to enhance user engagement.",
            // cardImage: "https://play-lh.googleusercontent.com/mttSG2nLj_MOiSBRzhlUyrgukqtAaGsqTJYS5nn_0Uv1vu4QbiN_hURYbx2tCnL_oYM=w416-h235-rw",
            cardImage: "/images/projects/football_lounge_card.webp",
            image: "/images/projects/football_lounge.webp",
            technologies: ["Flutter", "Firebase", "Socket.io", "Real-time Chat", "Gaming"],
            playstore: "https://play.google.com/store/apps/details?id=com.football_lounge.app&pcampaignid=web_share&pli=1",
            appstore: "https://apps.apple.com/in/app/football-lounge/id6479597032",
            featured: false,
            status: "completed",
            year: "2024"
        },
        {
            id: 3,
            title: "Navigate Bharat",
            description: "Video gateway of India - A mobile app providing public access to official Government of India videos.",
            longDescription: "Built a mobile app to provide public access to official Government of India videos, increasing information accessibility by 40%. Enhanced video playback with features like resolution adjustment, speed control, and offline viewing.",
            image: "/images/projects/navbharatlogo.png",
            technologies: ["Flutter", "Better Player", "Video Streaming", "Offline Viewing"],
            github: "https://github.com/manavgupta/navigate-bharat",
            live: "https://navigatebharat.gov.in/home",
            featured: false,
            status: "completed",
            year: "2023"
        },
        {
            id: 4,
            title: "Sanatana: The Eternal Living",
            description: "Daily Gita & Ramayana wisdom app - Timeless shlokas with clear explanations, soothing background music, and multilingual support for a daily spiritual habit.",
            longDescription: "Begin each day with timeless wisdom from the Bhagavad Gita and Ramayana. Sanatana brings the sacred shlokas to life with clear explanations, soothing background music, and support for multiple languages — so ancient teachings feel personal, practical, and easy to understand. Whether a lifelong devotee or just beginning a spiritual journey, Sanatana helps build a simple daily habit of reflection and learning.\n\nA verse for every day: receive a thoughtfully chosen shloka each day, the same verse shared by the whole community, along with its meaning and a practical lesson to carry into daily life.\n\nDeep, easy-to-understand explanations: every verse comes with context and interpretation that make profound teachings accessible — no Sanskrit degree required.\n\nA calming atmosphere: soothing background music plays while you read, perfect for a morning routine, commute, or quiet reflection.\n\nRead in your language: explore content in English, Hindi, Sanskrit, and Telugu, with the original Sanskrit shloka alongside translations.\n\nExplore the full scriptures: browse chapter by chapter through the Bhagavad Gita and Ramayana, and search by chapter and verse (like \"chapter 2\" or \"2:47\").\n\nTrack your journey: bookmark verses, revisit reading history, and keep a daily practice going with streaks and progress tracking.\n\nUse it your way: start instantly as a guest with no account needed, or sign in with Google to keep bookmarks and progress in sync.\n\nBuilt with Flutter and Firebase for a smooth cross-platform experience, with Gemini AI powering contextual verse explanations and a conversational \"Ask the Gita\" feature.",
            image: "/images/projects/sanatana.png",
            cardImage: "/images/projects/sanatana_card.png",
            technologies: ["Flutter", "Firebase", "Gemini AI"],
            playstore: "https://play.google.com/store/apps/details?id=com.sanatana.app",
            featured: true,
            status: "completed",
            year: "2026"
        }
    ],
    
    skills: {
        frontend: ["React", "JavaScript", "HTML5", "CSS3", "Flutter", "Dart"],
        backend: ["Firebase", "REST APIs", "MongoDB", "SQLite", "Hive", "ObjectBox"],
        frameworks: ["Flutter", "ReactJS"],
        database: ["MongoDB", "SQLite", "Hive", "ObjectBox", "Firebase"],
        tools: ["Git", "GitHub", "GitLab", "Postman", "Visual Studio Code", "Xcode", "Android Studio", "SonarQube"],
        mobile: ["Flutter", "Dart", "Android Development", "iOS Development", "Cross-platform"],
        thirdParty: ["Firebase", "Twilio", "Jitsi Meet", "Intercom", "Azure", "AWS", "Google Maps SDK"]
    },
    
    stack: [
        { name: "Flutter", category: "Mobile Framework", icon: "📱" },
        { name: "ReactJS", category: "Web Framework", icon: "⚛️" },
        { name: "HTML", category: "Markup Language", icon: "🌐" },
        { name: "CSS", category: "Styling Language", icon: "🎨" },
        { name: "Git", category: "Version Control", icon: "📋" },
        { name: "FastAPI", category: "Backend Framework", icon: "⚡" },
        { name: "Firebase", category: "Backend Service", icon: "🔥" },
        { name: "MongoDB", category: "Database", icon: "🍃" }
    ],
    
    education: [
        {
            id: 1,
            institution: "Government College of Engineering & Technology",
            degree: "Bachelor of Engineering in Computer Engineering",
            duration: "2019 - 2023",
            location: "Jammu, J&K",
            grade: "8.7 CGPA",
            description: "Focused on software engineering principles, data structures, algorithms, and mobile application development.",
            achievements: [
                "Graduated with 8.7 CGPA",
                "Specialized in software engineering and mobile development",
                "Active participant in coding competitions and tech events"
            ]
        }
    ],
    
    testimonials: [
        {
            id: 1,
            name: "Rahul Sharma",
            position: "Senior Developer at Grarri",
            company: "Grarri Pvt Ltd",
            content: "Manav is an exceptional developer with strong technical skills in Flutter and mobile development. His ability to deliver high-quality code and lead technical architecture makes him a valuable team member.",
            avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
            rating: 5
        },
        {
            id: 2,
            name: "Priya Patel",
            position: "Project Manager at Appventurez",
            company: "Appventurez Mobitech",
            content: "Working with Manav has been a pleasure. He consistently delivers projects on time and his attention to detail is remarkable. His Flutter expertise helped us launch several successful mobile applications.",
            avatar: "https://images.unsplash.com/photo-1494790108755-2616b332c265?w=150&h=150&fit=crop&crop=face",
            rating: 5
        }
    ],
    
    blogCategories: [
        { id: "tech", name: "Technology", color: "bg-blue-500" },
        { id: "tutorial", name: "Tutorial", color: "bg-green-500" },
        { id: "career", name: "Career", color: "bg-purple-500" },
        { id: "mobile", name: "Mobile Dev", color: "bg-orange-500" }
    ],
    
    blogPosts: [
        {
            id: 1,
            title: "Building Scalable Flutter Apps: Lessons from Real-World Projects",
            slug: "building-scalable-flutter-apps-real-world-lessons",
            excerpt: "Learn how to build Flutter applications that scale efficiently with proper architecture, state management, and performance optimization techniques from my experience building apps for various industries.",
            author: "Manav Gupta",
            publishedAt: "2024-01-15",
            readTime: "8 min read",
            category: "mobile",
            tags: ["flutter", "mobile-development", "performance", "architecture"],
            featured: true,
            image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&h=400&fit=crop",
            likes: 245,
            comments: 18
        },
        {
            id: 2,
            title: "Flutter State Management: Provider vs Bloc in Practice",
            slug: "flutter-state-management-provider-vs-bloc",
            excerpt: "A comprehensive comparison of Provider and Bloc state management solutions in Flutter, based on hands-on experience building production applications.",
            author: "Manav Gupta",
            publishedAt: "2024-01-08",
            readTime: "12 min read",
            category: "tutorial",
            tags: ["flutter", "state-management", "provider", "bloc"],
            featured: true,
            image: "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=800&h=400&fit=crop",
            likes: 189,
            comments: 25
        },
        {
            id: 3,
            title: "My Journey from Student to Software Engineer",
            slug: "journey-student-to-software-engineer",
            excerpt: "Reflecting on my path from computer science student to professional software engineer, including challenges, learnings, and career milestones.",
            author: "Manav Gupta",
            publishedAt: "2024-01-01",
            readTime: "6 min read",
            category: "career",
            tags: ["career", "journey", "software-engineering", "advice"],
            featured: false,
            image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=400&fit=crop",
            likes: 156,
            comments: 32
        },
        {
            id: 4,
            title: "Integrating Real-time Features in Flutter with Socket.io",
            slug: "flutter-realtime-features-socketio",
            excerpt: "A practical guide to implementing real-time communication features in Flutter applications using Socket.io, based on my experience building Football Lounge.",
            author: "Manav Gupta",
            publishedAt: "2023-12-28",
            readTime: "10 min read",
            category: "tutorial",
            tags: ["flutter", "socket.io", "real-time", "communication"],
            featured: false,
            image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=800&h=400&fit=crop",
            likes: 203,
            comments: 47
        }
    ],

    shelf: {
        books: [
            {
                id: 1,
                title: "The Pragmatic Programmer",
                author: "David Thomas & Andrew Hunt"
            },
            {
                id: 2,
                title: "Clean Code",
                author: "Robert C. Martin"
            },
            {
                id: 3,
                title: "Atomic Habits",
                author: "James Clear"
            },
            {
                id: 4,
                title: "Deep Work",
                author: "Cal Newport"
            },
            {
                id: 5,
                title: "Zero to One",
                author: "Peter Thiel"
            },
            {
                id: 6,
                title: "Designing Data-Intensive Applications",
                author: "Martin Kleppmann"
            },
            {
                id: 7,
                title: "The Psychology of Money",
                author: "Morgan Housel"
            },
            {
                id: 8,
                title: "Shoe Dog",
                author: "Phil Knight"
            },
            {
                id: 9,
                title: "Thinking, Fast and Slow",
                author: "Daniel Kahneman"
            },
            {
                id: 10,
                title: "The Almanack of Naval Ravikant",
                author: "Eric Jorgenson"
            }
        ],
        papers: [
            {
                id: 1,
                title: "Attention Is All You Need",
                authors: "Vaswani et al.",
                venue: "NeurIPS 2017",
                url: "https://arxiv.org/abs/1706.03762"
            },
            {
                id: 2,
                title: "MapReduce: Simplified Data Processing on Large Clusters",
                authors: "Dean & Ghemawat",
                venue: "OSDI 2004",
                url: "https://research.google/pubs/mapreduce-simplified-data-processing-on-large-clusters/"
            },
            {
                id: 3,
                title: "Dynamo: Amazon's Highly Available Key-value Store",
                authors: "DeCandia et al.",
                venue: "SOSP 2007",
                url: "https://www.allthingsdistributed.com/files/amazon-dynamo-sosp2007.pdf"
            },
            {
                id: 4,
                title: "The Google File System",
                authors: "Ghemawat, Gobioff & Leung",
                venue: "SOSP 2003",
                url: "https://research.google/pubs/the-google-file-system/"
            },
            {
                id: 5,
                title: "A Flutter-based Approach to Cross-platform Development",
                authors: "Stoll & Gonçalves",
                venue: "IEEE 2020",
                url: "https://ieeexplore.ieee.org/document/9226427"
            }
        ]
    }
};